export default {
  daysToDate: 0,
  displayYear: '',
  agrinoteImgDate: 0,
  agrinoteImgId: 0,
  maxDate: ''
}
